module.exports = __webpack_public_path__ + "static/media/grid.e5fcf8cf.svg";